import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { TabDetail } from "./types";


const __default__ = {
	name: 'SettingsPage'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tabNames: { default: undefined },
    tabDetails: { default: undefined },
    isActionsVisible: { type: Boolean, default: true },
    activeTab: { default: 0 }
  },
  emits: ["updateActiveTab"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'updateActiveTab', item: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tabNames: Array<string>, tabDetails: TabDetail[], isActionsVisible: boolean, activeTab:number };



watch(
  () => props.activeTab,
  () => {
    tabs.value = props.activeTab
  }
)

const tabs = ref(props.activeTab);
const footer = ref<HTMLElement>();
const cssVars = computed(() => {
  if (!footer.value) return {}
  return {
    '--footer-height': `${footer.value.offsetHeight}px`
  }
});

const computedTabDetails = computed(() => props.tabDetails || (props.tabNames?.map((tabName) => ({ name: tabName }))))



function updateActiveTab(tab: number) {
  emits('updateActiveTab', tab)
}

return { __sfc: true,props, tabs, footer, cssVars, computedTabDetails, emits, updateActiveTab }
}

})